import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend,
} from "chart.js";

import { Bar } from "react-chartjs-2";

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

export default function ChartSingleBar({ indicator, type = "money" }) {
  if (!indicator) return null;

  const label = "Atual";

  const projetado = indicator.projetada ?? indicator.projetado ?? 0;

  const alcancado = indicator.alcancada ?? indicator.alcancado ?? 0;

  const format = (v) =>
    type === "percent"
      ? `${v.toLocaleString("pt-BR", { minimumFractionDigits: 2 })}%`
      : `R$ ${v.toLocaleString("pt-BR", { minimumFractionDigits: 2 })}`;

  return (
    <Bar
      data={{
        labels: [label],
        datasets: [
          {
            label: "Dados Projetados",
            data: [projetado],
            backgroundColor: "rgba(146,133,249,0.45)",
            borderColor: "rgba(146,133,249,0.8)",
            borderWidth: 1,
            categoryPercentage: 0.8,
            barPercentage: 0.9,
          },
          {
            label: "Dados Alcançados",
            data: [alcancado],
            backgroundColor: "rgba(244,69,90,0.35)",
            borderColor: "rgba(244,69,90,0.35)",
            borderWidth: 1,
            categoryPercentage: 0.8,
            barPercentage: 0.9,
          },
        ],
      }}
      height={200}
      options={{
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            position: "bottom",
            labels: {
              boxWidth: 10,
              usePointStyle: true,
              pointStyle: "circle",
              font: { size: 9 },
            },
          },
          tooltip: {
            callbacks: {
              label: (ctx) => format(ctx.raw),
            },
          },
        },
        scales: {
          y: {
            beginAtZero: true,
            grid: { color: "rgba(0,0,0,0.06)" },
            ticks: { font: { size: 11 } },
          },
          x: {
            grid: { display: false },
            ticks: { font: { size: 11 } },
          },
        },
      }}
    />
  );
}
